// extracted by mini-css-extract-plugin
module.exports = {"callouts":"style__callouts__yLExl"};